<template>
  <div class="mb-4">
    <template v-if="!noDescription && uploadType === 'previousReport'">
      <br/>
      <h4>Upload a PDF of the positive control report below</h4>
      <div class="text--secondary mb-8">
        If the positive control report is not in a PDF format, please email this
        report to
        <a href="mailto:VCGSgenomics@vcgs.org.au">VCGSgenomics@vcgs.org.au</a>
        and include the 6 character order ID in the subject of your email.
      </div>
    </template>
    <template v-if="!noDescription && uploadType === 'consent'">
      <h3 class="mt-8 mb-4" style="color: black;">
        Upload a PDF of the signed informed
        <a
          href="https://www.vcgs.org.au/media/MGF_164_consent_form_genomic_testing_ef4111997e.pdf"
          target="_blank"
          >genomic consent</a
        >
        below
        <span v-if="optionalConsent" class="grey--text">(OPTIONAL)</span>
      </h3>
      <p v-if="noCgApproval">
        The National Pathology Accreditation Advisory Council (NPAAC) standard
        (March 2023) requires that VCGS receives a copy of the signed informed
        consent. If the consent discussion is to be held at a later date, once
        completed, please email to
        <a href="mailto:VCGSgenomics@vcgs.org.au">VCGSgenomics@vcgs.org.au</a>
        and include the 6 character order ID in the subject of your email.
      </p>
      <p v-else>
        The National Pathology Accreditation Advisory Council (NPAAC) standard
        (March 2023) requires that VCGS receives a copy of the signed informed
        consent form before testing can proceed. If the consent form is not in a
        PDF format or unable to be uploaded at this time, please email to
        <a href="mailto:VCGSgenomics@vcgs.org.au">VCGSgenomics@vcgs.org.au</a>
        and include the 6 character order ID in the subject of your email.
      </p>
      <p>
        Please note: For Trio testing, consent is required for all 3
        individuals.
      </p>
    </template>

    <v-file-input
      outlined
      multiple
      show-size
      :label="inputLabel"
      counter
      :accept="MIME_TYPES"
      v-model="files"
      @change="handleUploadChange"
      :rules="required ? rulesRequired : rules"
    >
    </v-file-input>
  </div>
</template>

<script>
const MAX_FILE_SIZE = 1024 * 1024 * 10;
const MIME_TYPES = "application/pdf";

export default {
  props: {
    testId: String,
    testName: String,
    updateOnDestroy: Boolean,
    required: Boolean,
    uploadType: String,
    noDescription: {
      type: Boolean,
      default: false,
    },
    optionalConsent: {
      type: Boolean,
      default: false,
    },
    noCgApproval: {
      type: Boolean,
      default: false,
    },
    noAlert: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      MAX_FILE_SIZE,
      MIME_TYPES,
      files: [],
      rules: [
        (value) => {
          let totalSize = 0;

          value.map((ele) => (totalSize += ele.size));

          if (totalSize > MAX_FILE_SIZE) {
            return "Files should be less than 10MB";
          }

          for (const file of value) {
            if (file.type !== MIME_TYPES) {
              return "Only PDF files are allowed";
            }

            return true;
          }
        },
      ],
      rulesRequired: [
        (value) => {
          if (!value || !value.length) {
            return "Uploading files is required";
          }

          let totalSize = 0;

          value.map((ele) => (totalSize += ele.size));

          if (totalSize > MAX_FILE_SIZE) {
            return "Files should be less than 10MB";
          } else {
            return true;
          }
        },
      ],
    };
  },
  computed: {
    inputLabel() {
      return this.files && this.files.length === 0
        ? "Click here to upload your files"
        : "";
    },
  },
  beforeDestroy() {
    if (this.updateOnDestroy) {
      this.emitUpdateUploadObj({
        files: [],
        testId: this.testId,
        testName: this.testName,
      });
    }
  },
  methods: {
    handleUploadChange() {
      this.emitUpdateUploadObj({
        files: this.files,
        testId: this.testId,
        testName: this.testName,
      });
    },
    emitUpdateUploadObj(newObj) {
      this.$emit("updateUploadObj", newObj, this.uploadType);
    },
  },
};
</script>
